import React, { useState, useEffect } from 'react';
import { SignInButton } from '@clerk/clerk-react';
import './LandingPage.css';
import cadscribeLogo from '../assets/cadscribe.png';
import ModelViewer from './ChatInterface/ModelViewer';

const LandingPage = () => {
  const [loaded, setLoaded] = useState(false);
  const [mousePosition, setMousePosition] = useState({ x: 0, y: 0 });
  const [isHovering, setIsHovering] = useState(false);

  useEffect(() => {
    setLoaded(true);
  }, []);

// Update the handleMouseMove function in your React component
const handleMouseMove = (e) => {
  // Get the bounding rectangle of the landing container
  const container = e.currentTarget;
  const rect = container.getBoundingClientRect();
  
  // Calculate position relative to the container
  const x = e.clientX - rect.left;
  const y = e.clientY - rect.top;
  
  // Convert to percentage for better responsiveness
  const xPercent = (x / rect.width) * 100;
  const yPercent = (y / rect.height) * 100;
  
  document.documentElement.style.setProperty('--mouse-x', `${xPercent}%`);
  document.documentElement.style.setProperty('--mouse-y', `${yPercent}%`);
};

  const handleMouseEnter = () => {
  setIsHovering(true);
  document.documentElement.style.setProperty('--is-hovering', '1');
};
  const handleMouseLeave = () => {
  setIsHovering(false);
  document.documentElement.style.setProperty('--is-hovering', '0');
};


  

  return (
    <div
      className="landing-container"
      onMouseMove={handleMouseMove}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
    >
      <div className="dot-mask"></div>

      <header className="landing-header">
        <img src={cadscribeLogo} alt="CADscribe Logo" className="landing-logo" />
      </header>

      <div className={`main-content ${loaded ? 'loaded' : 'hidden'}`}>
        <h1>
          Unlock AI powered <strong>CAD generation</strong>.
        </h1>
        <p>
          Increase your efficiency and accelerate your design workflows by transforming text input into CAD
          models.
        </p>

        <div className="button-wrapper" style={{ marginBottom: '120px' }}>
          <SignInButton mode="modal">
            <button className="sign-in-button">Try it now!</button>
          </SignInButton>
          <a
            href={`mailto:dikens.celaj@cadscribelabs.com?subject=${encodeURIComponent(
              'Contact from Website'
            )}&body=${encodeURIComponent('Hello, I wanted to reach out about...')}`}
            className="contact-us-button"
          >
            Contact Us
          </a>
        </div>

        <div className="userText">
          <span>
            Create a 3x5 inches filetted faceplate, 0.25 inches thick and with 4 holes in the corners
          </span>
        </div>

        <div className="example-viewer-container">
          <ModelViewer stlFile="static/stl/example_faceplate.stl" objectId="example-cube" />
        </div>
      </div>

      <footer className="landing-footer">
        <p>&copy; {new Date().getFullYear()} CADscribe. All rights reserved.</p>
        <div className="social-links">
          {/* LinkedIn */}
          <a href="https://www.linkedin.com/company/cadscribe" target="_blank" rel="noopener noreferrer">
            <svg
              role="img"
              viewBox="0 0 24 24"
              xmlns="http://www.w3.org/2000/svg"
              style={{ width: '24px', height: '24px', fill: 'currentColor' }}
            >
              <title>LinkedIn</title>
              <path d="M20.447 20.452h-3.554v-5.569c0-1.325-.028-3.044-1.852-3.044-1.853 0-2.136 1.445-2.136 2.939v5.674H9.276V9.276h3.413v1.561h.045c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433a2.062 2.062 0 01-2.063-2.062 2.062 2.062 0 012.063-2.062c1.132 0 2.063.93 2.063 2.062a2.062 2.062 0 01-2.063 2.062zm1.787 13.019H3.55v-11.63h3.574v11.63zM22.227 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.456c.98 0 1.772-.773 1.772-1.729V1.729C24 .774 23.207 0 22.227 0z" />
            </svg>
          </a>

          {/* X / Twitter */}
          <a href="https://x.com/betapekens" target="_blank" rel="noopener noreferrer">
            <svg
              role="img"
              viewBox="0 0 24 24"
              xmlns="http://www.w3.org/2000/svg"
              style={{ width: '24px', height: '24px', fill: 'currentColor' }}
            >
              <title>X</title>
              <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z" />
            </svg>
          </a>
        </div>
      </footer>
    </div>
  );
};

export default LandingPage;
